import { render, staticRenderFns } from "./InformationBoard.vue?vue&type=template&id=f15ce1ea&"
var script = {}
import style0 from "./InformationBoard.vue?vue&type=style&index=0&id=f15ce1ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports